<script>
import resources from './resources'

export default {
  name: 'gadget-agendas-statistics',

  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-estatisticas-agendas.white-bg.wrapper.full-width.gadget.paciente
    .gadget-title
      | Minhas Estatísticas de Consultas
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    .item
      .icon
        span.icon 
      .total
        | {{ scheduled }}
      .title Agendadas
    .item
      .icon
        span.icon 
      .total
        | {{ canceled }}
      .title Canceladas
    .item
      .icon
        span.icon 
      .total
        | {{ attended }}
      .title Realizadas
    .item
      .icon
        span.icon 
      .total
        | {{ total }}
      .title Total
</template>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/components/agendas-statistics/statistics.vue